
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/[customer]",
      function () {
        return require("private-next-pages/customers/[customer].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/[customer]"])
      });
    }
  